module.exports = __webpack_public_path__ + "img/fa-solid-900.be869a65.svg";